import React, { useState, useEffect } from 'react';
import { Banner } from '../../interfaces/Banner.interface';
import RecipeOfTheDay from '../RecipeOfTheDay.tsx';

interface BannerCarouselProps {
  banners: Banner[];
}

const BannerCarousel: React.FC<BannerCarouselProps> = ({ banners }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Cambiar la imagen automáticamente cada 10 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 10000); // 10000ms = 10s
    return () => clearInterval(interval);
  }, [banners.length]);

  // Obtener el banner actual
  const banner = banners[currentIndex];

  return (
    <RecipeOfTheDay
      banner={banner}
    />
  );
};

export default BannerCarousel;
